import React, { useState, useEffect, useRef } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

const FunMathQuizGame = () => {
  const [score, setScore] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [feedbackColor, setFeedbackColor] = useState('');
  const [confettiElements, setConfettiElements] = useState([]);
  const [answerValue, setAnswerValue] = useState('');

  const inputRef = useRef(null);

  const questions = [
    { q: "What is 7 × 5?", a: 35 },
    { q: "What is 9 × 6?", a: 54 },
    { q: "What is 11 × 14?", a: 154 },
    { q: "What is 25 × 8?", a: 200 },
    { q: "What is 50 × 7?", a: 350 },
    { q: "What is 23 × 4?", a: 92 },
    { q: "What is 41 × 3?", a: 123 },
    { q: "What is 36 × 7?", a: 252 },
    { q: "What is 58 × 2?", a: 116 },
    { q: "What is 67 × 5?", a: 335 },
    { q: "What is 25²?", a: 625 },
    { q: "What is 85²?", a: 7225 },
    { q: "What is the square of a number just above 50: 51²?", a: 2601 },
    { q: "What is 95²?", a: 9025 },
    { q: "What is 49²?", a: 2401 },
    { q: "1000 – 476 = ?", a: 524 },
    { q: "10,000 – 2,589 = ?", a: 7411 },
    { q: "1000 – 783 = ?", a: 217 },
    { q: "10,000 – 9,321 = ?", a: 679 },
    { q: "1000 – 305 = ?", a: 695 },
    { q: "84 ÷ 6 = ?", a: 14 },
    { q: "96 ÷ 8 = ?", a: 12 },
    { q: "72 ÷ 3 = ?", a: 24 },
    { q: "64÷ 4 = ?", a: 16 },
    { q: "85 ÷ 5 = ?", a: 17 },
    { q: "Divide 56 by 4 ?", a: 14 },
    { q: "81 ÷ 9 = ?", a: 9 },
    { q: "63 ÷ 7 = ?", a: 9 },
    { q: "72 ÷ 6 = ?", a: 12 },
    { q: "90 ÷ 10 = ?", a: 9 },
  ];

  const normalizeAnswer = (input) => input.trim().toLowerCase().replace(/\s+/g, '');

  const checkAnswer = (e) => {
    e.preventDefault();
    const userAnswerRaw = answerValue;
    const correctAnswer = questions[currentQuestionIndex].a;
    let isCorrect = false;

    if (typeof correctAnswer === 'number') {
      isCorrect = Number(userAnswerRaw) === correctAnswer;
    } else {
      isCorrect = normalizeAnswer(userAnswerRaw) === normalizeAnswer(correctAnswer);
    }

    if (isCorrect) {
      setScore((prev) => prev + 1);
      setFeedback(' Correct!');
      setFeedbackColor('#2e7d32');
      showConfetti();
    } else {
      setFeedback(`Wrongsy! The correct answer is: ${correctAnswer}`);
      setFeedbackColor('#c62828');
    }

    // Wait before going to next question
    setTimeout(() => {
      setCurrentQuestionIndex((prev) => prev + 1);
      setFeedback('');
    }, 2000);
  };

  const showConfetti = () => {
    const elements = [];
    for (let i = 0; i < 30; i++) {
      elements.push(
        <div
          key={i + Math.random()}
          style={{
            position: 'fixed',
            width: '10px',
            height: '10px',
            backgroundColor: `hsl(${Math.floor(Math.random() * 360)}, 70%, 60%)`,
            opacity: 0.8,
            pointerEvents: 'none',
            animation: `fall ${2 + Math.random() * 2}s linear forwards`,
            left: Math.random() * window.innerWidth + 'px'
          }}
        ></div>
      );
    }
    setConfettiElements(elements);
    setTimeout(() => setConfettiElements([]), 3000);
  };

  const question = questions[currentQuestionIndex];

  // Clear and focus input when question changes
  useEffect(() => {
    setAnswerValue('');
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [currentQuestionIndex]);

  // End of quiz event
  useEffect(() => {
    if (currentQuestionIndex === questions.length) {
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    }
  }, [currentQuestionIndex]);

  return (
    <div style={{
      fontFamily: 'Poppins, sans-serif',
      backgroundImage: 'url("https://static.vecteezy.com/system/resources/thumbnails/021/826/876/small_2x/hand-drawn-math-symbols-icon-in-flat-style-mathematics-formula-illustration-on-isolated-background-school-education-sign-business-concept-vector.jpg")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      minHeight: '100vh',
      overflowX: 'hidden'
    }}>
      {confettiElements}
      <div style={{
        display: 'grid',
        placeItems: 'center',
        minHeight: '100vh',
        padding: '1rem'
      }}>
        <div style={{
          background: '#fff',
          border: '3px solid #4a148c',
          borderRadius: '30px',
          padding: '2.5rem 1.5rem',
          maxWidth: '500px',
          width: '100%',
          textAlign: 'center',
          boxSizing: 'border-box'
        }}>
          <h2 style={{
            fontSize: 'clamp(1.5rem, 5vw, 2.2rem)',
            color: '#4a148c',
            fontFamily: 'Comic Neue, cursive',
            textShadow: '1px 1px 3px #b39ddb'
          }}>
            Score → <span>{score}</span>
          </h2>
          <h3 style={{
            fontSize: 'clamp(1.2rem, 4vw, 1.5rem)',
            margin: '1.5rem 0 2rem',
            minHeight: '3em'
          }}>
            {question ? question.q : `🎉 Quiz Complete! Your final score is ${score} / ${questions.length}`}
          </h3>

          {question && (
            <form onSubmit={checkAnswer} style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              <input
                ref={inputRef}
                name="answer"
                type="text"
                required
                autoComplete="off"
                inputMode="numeric"
                value={answerValue}
                onChange={(e) => setAnswerValue(e.target.value)}
                style={{
                  fontSize: 'clamp(1rem, 4vw, 1.5rem)',
                  padding: '15px',
                  border: '2px solid #4a148c',
                  borderRadius: '15px',
                  textAlign: 'center',
                  width: '100%'
                }}
              />
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem', marginTop: '1rem' }}>
  <button
    type="button"
    onClick={() => {
      setCurrentQuestionIndex((prev) => Math.max(prev - 1, 0));
      setFeedback('');
    }}
    style={{
      flex: 1,
      padding: '1rem',
      backgroundColor: '#6a1b9a',
      color: '#fff',
      fontSize: '1rem',
      fontWeight: 700,
      border: 'none',
      borderRadius: '15px',
      cursor: currentQuestionIndex === 0 ? 'not-allowed' : 'pointer',
      opacity: currentQuestionIndex === 0 ? 0.5 : 1,
    }}
    disabled={currentQuestionIndex === 0}
  >
    Previous
  </button>

  <button
    type="button"
    onClick={() => {
      setCurrentQuestionIndex((prev) =>
        Math.min(prev + 1, questions.length - 1)
      );
      setFeedback('');
    }}
    style={{
      flex: 1,
      padding: '1rem',
      backgroundColor: '#4a148c',
      color: '#fff',
      fontSize: '1rem',
      fontWeight: 700,
      border: 'none',
      borderRadius: '15px',
      cursor:
        currentQuestionIndex === questions.length - 1 ? 'not-allowed' : 'pointer',
      opacity: currentQuestionIndex === questions.length - 1 ? 0.5 : 1,
    }}
    disabled={currentQuestionIndex === questions.length - 1}
  >
    Next
  </button>
</div>

              <button
                type="submit"
                style={{
                  padding: '15px',
                  backgroundColor: '#4a148c',
                  color: '#fff',
                  fontSize: 'clamp(1.1rem, 4vw, 1.5rem)',
                  fontWeight: 700,
                  border: 'none',
                  borderRadius: '15px',
                  cursor: 'pointer'
                }}
              >
                Submit
              </button>
            </form>
          )}

          <div style={{
            fontSize: 'clamp(1rem, 3vw, 1.3rem)',
            marginTop: '1.2rem',
            fontWeight: 700,
            fontFamily: 'Comic Neue, cursive',
            color: feedbackColor,
            minHeight: '30px'
          }}>
            {feedback}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fall {
          0% { transform: translateY(0) rotate(0deg); opacity: 1; }
          100% { transform: translateY(600px) rotate(360deg); opacity: 0; }
        }
      `}</style>
    </div>
  );
};

export default FunMathQuizGame;
